// Centralized, machine-readable business/entity information — the single
// source of truth for JSON-LD structured data, the AI knowledge layer, and
// generated /ai/*.json files.
//
// Every value here is copied from an already-verified real source elsewhere
// in this codebase — nothing is invented. If a value changes, update it here
// AND at its original source (listed per field below) so they stay in sync;
// this file does not replace those UI components, it mirrors their real data
// for machine consumption.
//
// Sources:
// - phones/email/address: src/components/feature/Footer.tsx,
//   src/mocks/homeData.ts (contactInfo)
// - social links: src/components/feature/FloatingSocialIcons.tsx
// - PAN/GST: src/utils/invoiceDocument.ts (used on real generated invoices —
//   confirmed live business registration numbers, not placeholders)
// - founding date, address components: src/pages/about/campus/page.tsx copy
//   ("established on 13 May 2013"), index.html geo meta tags

export const BUSINESS = {
  legalName: "National Institute of Mountaineering and Adventure Sports",
  shortName: "NIMAS",
  alternateName: "NIMAS Dirang",
  description:
    "India's premier national institute for mountaineering and adventure sports training under the Ministry of Defence, Government of India. World-class courses across Land, Air and Aqua verticals in the Eastern Himalayas.",
  url: "https://nimasdirang.com",
  // Real logo asset actually served by this site (index.html's own favicon
  // link and Logo.tsx both use this exact file) — NOT the old
  // "/logo.png" reference that was in home/page.tsx's inline schema, which
  // doesn't exist on this site and would have 404'd for anything reading it.
  logo: "https://nimasdirang.com/images/generated/compressed_WhatsApp-Image-2026-07-18-at-11.45.30-AM.webp",
  foundingDate: "2013-05-13",
  parentOrganization: "Ministry of Defence, Government of India",
  address: {
    streetAddress: "NIMAS, Dirang",
    addressLocality: "Dirang",
    addressRegion: "Arunachal Pradesh",
    postalCode: "790101",
    addressCountry: "IN",
    // Full formatted string, matching Footer.tsx / PageBanner address blocks verbatim.
    full: "NIMAS, Dirang, West Kameng District, Arunachal Pradesh - 790101, India",
  },
  geo: {
    latitude: 27.3522,
    longitude: 92.3667,
  },
  phones: ["+91-97742-31855", "+91-76400-02112"],
  email: "info@nimasdirang.com",
  panNumber: "AAEFU0850G",
  gstNumber: "06AAEFU0850G1ZE",
  socialLinks: {
    instagram: "https://www.instagram.com/nimas_dirang",
    facebook: "https://www.facebook.com/nimas2018",
    youtube: "https://www.youtube.com/@nimasdirang",
    twitter: "https://x.com/dirangnimas",
  },
  languages: ["English", "Hindi"],
} as const;

export const SITE = {
  name: "NIMAS Dirang",
  url: "https://nimasdirang.com",
  defaultImage: "/images/generated/default-seo-banner.png",
} as const;
